import { MenuTile } from '../../types';
import { getRandomLengthString } from '../../utils';
import { apps } from '../../utils/mockData';
import { Menu } from '../../generated/graphql';
import { venueHasBrands } from '../../utils/brand';

export type TileSection = {
  name: string;
  menus: [MenuTile, ...MenuTile[]];
};

type TempSections = {
  [id: string]: { name: string; menus: [MenuTile, ...MenuTile[]] };
};
export const groupByBrand = (menus: Menu[], venueSectionName = 'Your menus'): TileSection[] => {
  const hasBrands = venueHasBrands(menus);

  const sections: TempSections = menus
    .map(({ mmId, name, neverPublished, apps, busyUntil = null, surcharge = null }) => ({
      mmId,
      name,
      neverPublished,
      apps,
      busyUntil,
      surcharge
    }))
    .reduce((acc: TempSections, menu) => {
      const id = menu.apps[0]?.brand?.hashedId ?? 'venue';
      const sectionName = menu.apps[0]?.brand?.name ?? venueSectionName;
      return {
        ...acc,
        [id]: {
          name: sectionName,
          menus: [...(acc[id]?.menus ?? []), { ...menu, name: hasBrands ? `${sectionName} ${menu.name}` : menu.name }]
        }
      };
    }, {});

  return Object.values(sections)
    .map(({ name, menus }) => ({
      name,
      menus: menus.sort((a, b) => a.name.localeCompare(b.name))
    }))
    .sort((a, b) => {
      if (a.name === venueSectionName) return -1;
      if (b.name === venueSectionName) return 1;
      return a.name.localeCompare(b.name);
    });
};

export const defaultMenuSection: TileSection = {
  name: 'Your Menu',
  menus: [
    {
      mmId: 'abc123',
      name: getRandomLengthString(15, 25),
      apps: [apps[0]],
      neverPublished: false
    },
    {
      mmId: 'abc321',
      name: getRandomLengthString(15, 25),
      apps: [apps[1]],
      neverPublished: false
    },
    {
      mmId: 'abc456',
      name: getRandomLengthString(15, 25),
      apps: [apps[2]],
      neverPublished: false
    }
  ]
};
